import { render, staticRenderFns } from "./batchreport.vue?vue&type=template&id=35262010&scoped=true&"
import script from "./batchreport.vue?vue&type=script&lang=js&"
export * from "./batchreport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35262010",
  null
  
)

export default component.exports